import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PinLocationBIcon, RadiusIcon } from '@/assets';
import { LabeledContent } from '@/components/layouts';
import { DATE_TIME_WITH_ZONE_FORMAT } from '@/constants/dates';
import { makeSelectTimezone } from 'containers/App/selectors';
import { COLORS } from 'theme';
import { getFormattedTime } from 'utils/v2';

import { InfoWindowContentContainer } from '../../Map.styles';
import MarkerWithInfoWindow from '../MarkerWithInfoWindow';

const DropOffMarker = ({ position, formattedAddress, dropOffDateTime }) => {
  const timeZone = useSelector(makeSelectTimezone());

  const infoWindowContent = useMemo(
    () => (
      <InfoWindowContentContainer>
        <LabeledContent content={formattedAddress} label="To" />
        {dropOffDateTime && (
          <LabeledContent
            content={getFormattedTime(dropOffDateTime, {
              format: DATE_TIME_WITH_ZONE_FORMAT,
              zone: timeZone,
            })}
            label="Drop-Off Time"
          />
        )}
      </InfoWindowContentContainer>
    ),
    [formattedAddress, dropOffDateTime],
  );

  return (
    <MarkerWithInfoWindow
      position={position}
      infoWindowContent={infoWindowContent}
    >
      <RadiusIcon
        size="48px"
        color={COLORS.kinetikBlue}
        sx={{
          position: 'absolute',
          transform: 'translateY(50%)',
          zIndex: -1,
        }}
      />
      <PinLocationBIcon size="48px" primaryColor={COLORS.kinetikBlue} />
    </MarkerWithInfoWindow>
  );
};

DropOffMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  formattedAddress: PropTypes.string,
  dropOffDateTime: PropTypes.string,
};

export default DropOffMarker;
